import { AbstractIconComponent } from '../abstract.icon'
import { Component } from '@angular/core'

@Component({
  selector: 'icon-ev-connector-ccs2',
  templateUrl: './ev-connector-ccs2.icon.html',
  styles: [
    `
      svg {
        width: 60px;
        height: 60px;
      }
    `,
  ],
})
export class EvConnectorCcs2Component extends AbstractIconComponent {
  static icon = 'ev-connector-ccs2'
}
